import { render, staticRenderFns } from "./SidebarUserProfile.vue?vue&type=template&id=3663d288&scoped=true"
import script from "./SidebarUserProfile.vue?vue&type=script&lang=js"
export * from "./SidebarUserProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarUserProfile.vue?vue&type=style&index=0&id=3663d288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663d288",
  null
  
)

export default component.exports